import React, { useEffect, useState } from "react";
import moment from "moment-timezone";
import * as services from "../../store/service";
import { getFormattedDate } from "../../util/dateFormatting";
import i18nService from "../../util/Internationalization/i18n/i18n";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";

const PaymentHistoryDetailViewDialog = (props: any) => {
    const paymentInfo = { ...props };
    const [loading, isLoading] = useState(false);
    const [paymentDetails, setPaymentDetails] = useState<any>();

    useEffect(() => {
        if (props.isIDFUser) {
            isLoading(true);
            const requestBody = {
                date: paymentInfo.paymentInfo.date,
                amount: paymentInfo.paymentInfo.amount,
                cardLastFourDigits: paymentInfo.paymentInfo.cardNumber,
                paymentId: paymentInfo.paymentInfo.paymentId,
                purchasedReportId: paymentInfo.paymentInfo.purchasedReportId,
                hasAutomaticPayment: paymentInfo.paymentInfo.hasAutomaticPayment,
                hasUpgradeRecord: paymentInfo.paymentInfo.hasUpgradeRecord,
                hasPurchasedReportRecord: paymentInfo.paymentInfo.hasPurchasedReportRecord,
                hasAccountAdditionRecord: paymentInfo.paymentInfo.hasAccountAdditionRecord,
                isCredit: paymentInfo.paymentInfo.isCredit,
            };
            services
                .getPaymentReceiptDetail(requestBody)
                .then((data) => {
                    isLoading(false);
                    if (data.isSuccess) {
                        setPaymentDetails(data);
                    }
                })
                .catch(() => {
                    isLoading(false);
                });
        }
    }, []);

    const getPaymentInfoCycle = () => {
        if (paymentInfo.paymentInfo.cycle) {
            return paymentInfo.paymentInfo.cycle;
        }

        if (paymentDetails && paymentDetails.receiptData && paymentDetails.receiptData.billingCycle) {
            return paymentDetails.receiptData.billingCycle;
        }
    };

    const renderMembersDetails = () => {
        if (paymentDetails && paymentDetails.receiptData && paymentDetails.receiptData.memberList && paymentDetails.receiptData.memberList.paymentMemberList) {
            const paymentList = paymentDetails.receiptData.memberList.paymentMemberList;

            const getTotalCost = () => {
                let totalCost = 0.0;
                for (let index = 0; index < paymentList.length; index++) {
                    const cost = paymentList[index].price ? parseFloat(paymentList[index].price) : 0.0;
                    totalCost = totalCost + cost;
                }

                return totalCost;
            };

            if (paymentList.length > 0) {
                return (
                    <React.Fragment>
                        <div className="margin-top-l"></div>
                        <div className="box-content">
                            <h3>Members</h3>
                            <div className="table-container scroll" style={{ overflowY: "scroll", maxHeight: "200px" }}>
                                <table className="m-table-generic">
                                    <caption className="sr-only">Members</caption>
                                    <thead>
                                        <tr>
                                            <th scope="col">Member</th>
                                            <th scope="col">Plan</th>
                                            <th scope="col">Price</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {paymentList.map((paymentInfo: any, index: any) => (
                                            <tr key={index}>
                                                <td>
                                                    {paymentInfo.firstName ? paymentInfo.firstName : ""} {paymentInfo.lirstName ? paymentInfo.lirstName : ""} -{" "}
                                                    {paymentInfo.type ? paymentInfo.type : ""}
                                                </td>
                                                <td>{paymentInfo.plan ? paymentInfo.plan : ""}</td>
                                                <td>{paymentInfo.price ? paymentInfo.price : ""}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <th scope="col">Total</th>
                                            <th scope="col"></th>
                                            <th scope="col">{getTotalCost()}</th>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </React.Fragment>
                );
            }
        }
    };

    return (
        <React.Fragment>
            <div className="dialog-header">
                <div className="dialog-icon">
                    <RenderIcons iconName="history" />
                </div>
                <h1>Details Summary</h1>
            </div>
            <div className="margin-bottom-s"></div>
            <div className="dialog-body">
                <div className={loading ? "box-content loading" : "box-content"}>
                    <div role="grid" className="data-grid " id="monitored-info-personal-information-grid" aria-hidden="false">
                        {paymentInfo.paymentInfo.member && (
                            <div role="row" className="data-row row border-bottom-grey">
                                <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="label-full-name-display">
                                        Member
                                    </div>
                                </div>
                                <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter">
                                    <div className="data-value" aria-labelledby="label-full-name-display">
                                        {paymentInfo.paymentInfo.member}
                                    </div>
                                </div>
                            </div>
                        )}
                        {paymentInfo.paymentInfo.date && (
                            <div role="row" className="data-row row border-bottom-grey">
                                <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="label-email-display">
                                        Payment Date
                                    </div>
                                </div>
                                <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter">
                                    <div className="data-value" aria-labelledby="label-email-display">
                                        {getFormattedDate(i18nService.get("Country"), paymentInfo.paymentInfo.date)}
                                    </div>
                                </div>
                            </div>
                        )}
                        {paymentInfo.paymentInfo.cardNumber && (
                            <div role="row" className="data-row row border-bottom-grey">
                                <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="label-dob-display">
                                        Card Number
                                    </div>
                                </div>
                                <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter">
                                    <div className="data-value" aria-labelledby="label-dob-display">
                                        {paymentInfo.paymentInfo.cardNumber}
                                    </div>
                                </div>
                            </div>
                        )}
                        {paymentInfo.paymentInfo.plan && (
                            <div role="row" className="data-row row border-bottom-grey">
                                <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="label-ssn-display">
                                        Plan
                                    </div>
                                </div>
                                <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter">
                                    <div className="data-value" aria-labelledby="label-ssn-display">
                                        {paymentInfo.paymentInfo.plan}
                                    </div>
                                </div>
                            </div>
                        )}
                        {paymentInfo.paymentInfo.amount && (
                            <div role="row" className="data-row row border-bottom-grey">
                                <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="label-ssn-display">
                                        Price
                                    </div>
                                </div>
                                <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter">
                                    <div className="data-value" aria-labelledby="label-ssn-display">
                                        {paymentInfo.paymentInfo.amount}
                                    </div>
                                </div>
                            </div>
                        )}
                        {getPaymentInfoCycle() && (
                            <div role="row" className="data-row row border-bottom-grey">
                                <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="label-ssn-display">
                                        Billing Monthly Cycle
                                    </div>
                                </div>
                                <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter">
                                    <div className="data-value" aria-labelledby="label-ssn-display">
                                        {getPaymentInfoCycle()}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                {renderMembersDetails()}
            </div>
            <div className="dialog-footer">
                {paymentInfo.paymentInfo.transactionType == "Declined" && (
                    <div className="row between-xs">
                        <span className="required">
                            <span className="bold">Payment Declined - </span>We were unable to process this transaction. No charge was made on your card.
                        </span>
                    </div>
                )}

                <div className="margin-bottm-s"></div>
                <div className="row between-xs">
                    <div className="col-xs col-no-gutter flex-grow-null"></div>
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button type="submit" className="btn-default btn-primary" onClick={paymentInfo.handleClose}>
                            <span className="btn-text">Close</span>
                        </button>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default PaymentHistoryDetailViewDialog;
